import { render } from "./EmergencyLevel.vue?vue&type=template&id=fb08d908"
import script from "./EmergencyLevel.vue?vue&type=script&lang=js"
export * from "./EmergencyLevel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__